'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PRODUCT_CRM = exports.PRODUCT_CRM = 60;
var PRODUCT_MARKETING_FREE = exports.PRODUCT_MARKETING_FREE = 114;
var PRODUCT_MARKETING_STARTER = exports.PRODUCT_MARKETING_STARTER = 108;
var PRODUCT_MARKETING_STARTER_EMAIL = exports.PRODUCT_MARKETING_STARTER_EMAIL = 250;
var PRODUCT_MARKETING_STARTER_CONTACTS = exports.PRODUCT_MARKETING_STARTER_CONTACTS = 251;
var PRODUCT_MARKETING_BASIC = exports.PRODUCT_MARKETING_BASIC = 182;
var PRODUCT_MARKETING_BASIC_CONTACTS = exports.PRODUCT_MARKETING_BASIC_CONTACTS = 191;
var PRODUCT_MARKETING_PROFESSIONAL = exports.PRODUCT_MARKETING_PROFESSIONAL = 183;
var PRODUCT_MARKETING_PROFESSIONAL_CONTACTS = exports.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS = 192;
var PRODUCT_MARKETING_ENTERPRISE = exports.PRODUCT_MARKETING_ENTERPRISE = 184;
var PRODUCT_MARKETING_ENTERPRISE_CONTACTS = exports.PRODUCT_MARKETING_ENTERPRISE_CONTACTS = 193;
var PRODUCT_SALES_FREE = exports.PRODUCT_SALES_FREE = 115;
var PRODUCT_SALES_PRO_LEGACY = exports.PRODUCT_SALES_PRO_LEGACY = 1;
// This product is no longer active and is the legacy legacy sales pro
var PRODUCT_SALES_PRO_BUSINESS_USER = exports.PRODUCT_SALES_PRO_BUSINESS_USER = 4;
var PRODUCT_SALES_STARTER = exports.PRODUCT_SALES_STARTER = 186;
var PRODUCT_SALES_PROFESSIONAL = exports.PRODUCT_SALES_PROFESSIONAL = 198;
var PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = exports.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = 200;
var PRODUCT_SALES_ENTERPRISE = exports.PRODUCT_SALES_ENTERPRISE = 282;
var PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = exports.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = 283;

var PRODUCT_SERVICE_FREE = exports.PRODUCT_SERVICE_FREE = 296;
var PRODUCT_SERVICE_STARTER = exports.PRODUCT_SERVICE_STARTER = 261;
var PRODUCT_SERVICE_PROFESSIONAL = exports.PRODUCT_SERVICE_PROFESSIONAL = 262;
var PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = exports.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = 263;
var PRODUCT_SERVICE_ENTERPRISE = exports.PRODUCT_SERVICE_ENTERPRISE = 285;
var PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = exports.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = 286;

var ADDON_API = exports.ADDON_API = 113;
var ADDON_ADS = exports.ADDON_ADS = 9; // Deprecated
var ADDON_ADS_CAPACITY = exports.ADDON_ADS_CAPACITY = 300;
var ADDON_MARKETING_BASIC_WITH_PROFEESSIONAL_LIMITS = exports.ADDON_MARKETING_BASIC_WITH_PROFEESSIONAL_LIMITS = 38;
var ADDON_DEDICATED_IP = exports.ADDON_DEDICATED_IP = 33;
var ADDON_REPORTING = exports.ADDON_REPORTING = 2;
var ADDON_TRANSACTIONAL_EMAIL = exports.ADDON_TRANSACTIONAL_EMAIL = 41;
var ADDON_CUSTOM_SSL = exports.ADDON_CUSTOM_SSL = 52;
// TODO: Figure out merchandiseId
// export const ADDON_CUSTOM_SSL_THIRD_PARTY = null;
var ADDON_WEBSITE_STARTER = exports.ADDON_WEBSITE_STARTER = 54;
var ADDON_WEBSITE_UNLIMITED = exports.ADDON_WEBSITE_UNLIMITED = 10;
// TODO: Figure out merchandiseId
// export const ADDON_ADDITIONAL_PORTAL = null;
var ADDON_CMS = exports.ADDON_CMS = 256;
var ADDON_CMS_FREE = exports.ADDON_CMS_FREE = 1111111; // NOTE: CHANGE TO REAL MERCH ID ONCE WE HAVE IT
var ADDON_BRAND_DOMAIN = exports.ADDON_BRAND_DOMAIN = 297;

var SERVICE_FIRST_TEMPLATE_SETUP = exports.SERVICE_FIRST_TEMPLATE_SETUP = 18;
var SERVICE_TRAINING_MARKETING_FUNDAMENTALS = exports.SERVICE_TRAINING_MARKETING_FUNDAMENTALS = 268;
var SERVICE_TRAINING_SALES_MARKETING_ALIGNMENT = exports.SERVICE_TRAINING_SALES_MARKETING_ALIGNMENT = 269;
var SERVICE_TRAINING_CRM_MANAGEMENT = exports.SERVICE_TRAINING_CRM_MANAGEMENT = 270;
var SERVICE_TRAINING_AGENCY_ACCOUNT_MANAGEMENT = exports.SERVICE_TRAINING_AGENCY_ACCOUNT_MANAGEMENT = 267;
var SERVICE_INBOUND_CONSULTING_ONE_DAY = exports.SERVICE_INBOUND_CONSULTING_ONE_DAY = 36;
var SERVICE_INBOUND_CONSULTING_FOUR_HOUR = exports.SERVICE_INBOUND_CONSULTING_FOUR_HOUR = 37;
var SERVICE_DESIGNATED_TECHNICAL_SUPPORT = exports.SERVICE_DESIGNATED_TECHNICAL_SUPPORT = 39;
var SERVICE_TECH_CONSULTING_ONE_DAY = exports.SERVICE_TECH_CONSULTING_ONE_DAY = 245;
var SERVICE_TECH_CONSULTING_FOUR_HOURS = exports.SERVICE_TECH_CONSULTING_FOUR_HOURS = 275;
var SERVICE_CONSULTING_AGENCY_PIPELINE = exports.SERVICE_CONSULTING_AGENCY_PIPELINE = 175;
var SERVICE_CONSULTING_SALES_SKILLS = exports.SERVICE_CONSULTING_SALES_SKILLS = 176;
var SERVICE_MARKETING_BASIC_ONBOARDING = exports.SERVICE_MARKETING_BASIC_ONBOARDING = 42;
var SERVICE_MARKETING_PROFESSIONAL_ONBOARDING = exports.SERVICE_MARKETING_PROFESSIONAL_ONBOARDING = 45;
var SERVICE_MARKETING_ENTERPRISE_ONBOARDING = exports.SERVICE_MARKETING_ENTERPRISE_ONBOARDING = 44;
var SERVICE_CRM_SALES_STARTER_KIT = exports.SERVICE_CRM_SALES_STARTER_KIT = 57;
var SERVICE_SALES_PROFESSIONAL_ONBOARDING = exports.SERVICE_SALES_PROFESSIONAL_ONBOARDING = 254;
var SERVICE_SALES_ENTERPRISE_ONBOARDING = exports.SERVICE_SALES_ENTERPRISE_ONBOARDING = 288;
var SERVICE_SERVICE_PROFESSIONAL_ONBOARDING = exports.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING = 264;
var SERVICE_SERVICE_ENTERPRISE_ONBOARDING = exports.SERVICE_SERVICE_ENTERPRISE_ONBOARDING = 289;
var SERVICE_ENTERPRISE_SUITE_ONBOARDING = exports.SERVICE_ENTERPRISE_SUITE_ONBOARDING = 290;
var SERVICE_PROFESSIONAL_SUITE_ONBOARDING = exports.SERVICE_PROFESSIONAL_SUITE_ONBOARDING = 291;
var SERVICE_CONTENT_PROFESSIONAL_ONBOARDING = exports.SERVICE_CONTENT_PROFESSIONAL_ONBOARDING = 292;
var SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING = exports.SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING = 260;
var SERVICE_QUICK_START_CONSULTATION = exports.SERVICE_QUICK_START_CONSULTATION = 316;
var SERVICE_TECHNICAL_CONSULTING_ONGOING = exports.SERVICE_TECHNICAL_CONSULTING_ONGOING = 246;
var SERVICE_INBOUND_CONSULTING_MONTHLY = exports.SERVICE_INBOUND_CONSULTING_MONTHLY = 247;
var SERVICE_INBOUND_CONSULTING_ONGOING = exports.SERVICE_INBOUND_CONSULTING_ONGOING = 248;
var SERVICE_PREMIUM_CONSULTING = exports.SERVICE_PREMIUM_CONSULTING = 249;
var SERVICE_FIRST_TIME_FULL_MIGRATION = exports.SERVICE_FIRST_TIME_FULL_MIGRATION = 272;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/MerchandiseIds.js
// module id = 5
// module chunks = 3 4 5